class pdpUpsellItem extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll(".color-swatch");

    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", this.handleImageChange.bind(this));
    });

  }

  handleImageChange(event) {
    const images = this.querySelectorAll(".img-cart");
    let variantId = event.target.previousElementSibling.name;
    images.forEach((image) => {
      if (image.getAttribute("data-variant-id") == variantId) {
        image.style.display = "block";
      } else {
        image.style.display = "none";
      }
    });
  }
}

customElements.define("pdp-upsell-item", pdpUpsellItem);
